import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import trainer from '../../image/trainer.png';
import './About.css';
const About = () => {
    return (
        <div className='about my-5'>
            <Container>
                <Row lg={2} md={1} xs={1}>
                    <Col>
                        <div className="trainer">
                            <img src={trainer} alt="" className='ing-fluid' />
                        </div>
                    </Col>
                    <Col>
                        <div className="trainer-info py-5">
                            <h2 className='title'>ABOUT ME</h2>
                            <h4 className='fw-bold my-5'>
                                HI THERE, I AM YOUR NEW TRAINER MICHAEL
                            </h4>
                            
                            <p>
                                Today I will do what others won't, so tomorrow I can accomplish what others can't. We are what we repeatedly do. Excellence then is not an act but a habit. My passion and desire to explore the capabilities of the human body continue to evolve as I learn more and more.
                            </p>
                            <h5>My goals</h5>
                            <p className='my-3'>
                                I want to be a good web developer with more experience. I am providing Website Development & Designing, E-commerce through WordPress, Shopify. I want to be a hard working developer and a communicative one. I will do my best to achieve my goal .
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default About;